import { useMemo } from 'react';
import { JsonPointer } from '../../../utils/getDeepProperty';

function useMemoJsonPath(jsonPointer: JsonPointer, selectedLocalizedInfo?: string | undefined) {
	return useMemo(() => jsonPointer, [selectedLocalizedInfo]);
}

export default useMemoJsonPath;
